import React, { Component } from 'react';
import './SocialList.css';
import {
  TelegramShareButton,
  VKShareButton,
  OKShareButton,
} from 'react-share';
import exampleImage from '../Menu/imgs/r-telecom_logo.png';
import { HOST } from '../../constants/Fetch';

const SocialItem = item => (
  <a href={item.link} target="_blank" className={`socialList__item socialList__item--${item.social}`}>{item.social}</a>
);

class SocialList extends Component {
  render() {
    const shareUrl =  this.props.url;
    const title = this.props.title || 'Работа в ЭР-Телеком Холдинг';
    return (
      <div className={`socialList ${this.props.modifier ? this.props.modifier  : ''}`}>
        {
          // this.props.socials ?
          // this.props.socials.map((item, index) => (
          //   <SocialItem {...item} key={`socialItem-${index}`} />
          // )) :
              <React.Fragment>
                <SocialItem
                    link={"https://dzen.ru/teamertelecom?utm_referer=taplink.cc"}
                    // className="socialList__item socialList__item--dzen"
                    social={"dzen"}
                />
                <SocialItem
                    link={"https://rutube.ru/channel/23929586/"}
                  // className="socialList__item socialList__item--rutube"
                    social={"rutube"}
                />
                <SocialItem
                    link={"https://t.me/ertelecom_news"}
                    // className="socialList__item socialList__item--telegram"
                    social={"telegram"}
                />
                <SocialItem
                    link={"https://vk.com/rabotavdomru"}
                    // className="socialList__item socialList__item--vkontakte"
                    social={"vkontakte"}
                />
              </React.Fragment>
        }
      </div>
    );
  }
}

export default SocialList;



// WEBPACK FOOTER //
// ./src/components/SocialList/index.js